export default {
  // Endpoints
  loginEndpoint: '/user-auth/login',
  registerEndpoint: '/registration',
  refreshEndpoint: '/user-auth/refresh',
  logoutEndpoint: '/user-auth/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
}
